import { inject, Injectable } from '@angular/core';
import { ApiService } from '../utils/api/api-service';
import { Link } from '../utils/api/api-types/database-types';
import { CreateCheckoutResponse, CreateInviteResponse, CreateTransactionResponse, GetInternalLinkResponse, GetOfferResponse, GetPublicLinkResponse } from '../utils/api/api-types/api-types';

@Injectable({
  providedIn: 'root'
})
export class InviteService {
  private api = inject(ApiService);

  //----------------------------
  //---GET LINK (unauthorized) ---
  //----------------------------
  async getPublicLink(linkId: string): Promise<Link> {
    const result = (await this.api.call('getPublicLink', { linkId })) as GetPublicLinkResponse;
    return result.link
  }

  async getInternalLink(linkId: string): Promise<GetInternalLinkResponse> {
    const result = (await this.api.call('getInternalLink', { linkId })) as GetInternalLinkResponse;
    return result;
  }

  async createInviteLink(groupId: string): Promise<string> {
    const result = await this.api.call('createInvite', { groupId }) as CreateInviteResponse;
    return result.linkId;
  }

  async createPaymentTransaction(offerId: string, paymentReturnUrl: string, taxNumber?: string, paymentMethod?:string): Promise<CreateTransactionResponse> {
    // const result = (await this.api.call('createTransaction', { offerId, paymentReturnUrl, taxNumber, paymentMethod })) as CreateTransactionResponse;
    // return result;
    throw new Error('createPaymentTransaction is not implemented yet'); //just to secure no one is going to use it now (checkout first);
  }

  async createCheckoutSession(offerId: string, linkId:string,baseUrl:string): Promise<CreateCheckoutResponse> {
    const result = (await this.api.call('createCheckout', { offerId, linkId, baseUrl })) as CreateCheckoutResponse;
    return result;
  }

    async getOffer(offerId: string): Promise<GetOfferResponse> {
    const result = (await this.api.call('getOffer', { offerId })) as GetOfferResponse;
    return result;
  }

  async confirmFakeTransaction(offerId: string) {
    await this.api.call('confirmfaketransaction', { offerId });
  }

  async confirmTransaction(transactionId: string):Promise<boolean> {
    const result = await this.api.call('confirmTransaction', { transactionId }) as { success: boolean };
    return result.success;
  }

  async cancelCheckout(transactionId: string):Promise<boolean> {
    const result = await this.api.call('cancelCheckout', { transactionId }) as { success: boolean };
    return result.success;
  }

  async acceptInvite(linkId: string) {
    await this.api.call('acceptInvite', { linkId });
  }
  
}

